module.exports = __webpack_public_path__ + "img/new_platform.be35a16f.png";